import React, { useEffect, useState, useCallback } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import {FaEyeSlash } from 'react-icons/fa';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';


const Product = () => {
    const [loanMaster, setLoanMaster] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const token = Cookies.get('authToken');
    const [permissions, setPermissions] = useState([]);
    


    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]))
            .finally(() => setPageLoading(false));
    }, []);

    // Permission check helper
    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);


    const getAllLoanMaster = useCallback(() => {
        if (!hasPermission('Product', 'view')) return;
        axios.get(`${base_url}/api/product/view`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => {
                setLoanMaster(response.data.reverse());
            })
            .catch((error) => {
                console.error("Error fetching Product list:", error);
            });
    }, [token, hasPermission]);

    useEffect(() => {
        if (token) {
            getAllLoanMaster();
        }
    }, [token, getAllLoanMaster]);

    const handleExportLoanMaster = async () => {
         if (!hasPermission('Product', 'download')) {
            alert('You do not have permission to download Product.');
            return;
        }
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/export/loanToExport`, {
                responseType: 'blob'
            });

            // Create a link element
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Product_Master_data.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            console.log('Export Product Master successfully:', response.data);
            alert('Export Product Master successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Product Master not shown');
        } finally {
            setIsDownloading(false);
        }
    };

    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'borrower_name':
                    url = `${base_url}/api1/account/verifiedSearchByBorrowerName?borrowerName=${searchInput}`;
                    break;
                case 'borrower_id':
                    url = `${base_url}/api1/account/verifiedCustomerById?id=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api1/account/verifiedSearchByMobileNumber?mobileNumber=${searchInput}`;
                    break;
                default:
                    break;
            }
            axios.get(url).then(
                (response) => {
                    console.log(response.data);
                    setLoanMaster(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form action="">
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="loan_id">Loan Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" onClick={handleSearch} className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>

                                                <div className="col-md-2 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportLoanMaster}
                                                             disabled={isDownloading || !hasPermission('Product', 'download')}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Download 
                                                                </>

                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer  table-responsive mt-3'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : loanMaster.length > 0  ? (
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Product_Id</th>
                                                        <th>Loan_Amount</th>
                                                        <th>Interest</th>
                                                        <th>Interest_Type</th>
                                                        <th>Processing_Fee</th>
                                                        <th>Other_Deduction</th>
                                                        <th>Tenure_(Days)</th>
                                                        <th>Repayment_Type</th>
                                                        <th>Number_of_EMI</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loanMaster.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>US0{data.id}</td>
                                                            <td>{data.loanAmount}</td>
                                                            <td>{data.interestRate}</td>
                                                            <td>{data.interestRateType}</td>
                                                            <td>{data.processFee}</td>
                                                            <td>{data.otherDeduction}</td>
                                                            <td>{data.tenureInDays}</td>
                                                            <td>{data.repaymentType}</td>
                                                            <td>{data.numberOfEmi}</td>
                                                            <td className='iconss'>
                                                                <NavLink to={`/loanmaster/ViewProduct?loanId=${data.id}`}> <FaEyeSlash /></NavLink>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Loan Product"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Product;